// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".selected-items[data-v-5d4db9f1] {\n  min-width: 0;\n}", "",{"version":3,"sources":["/opt/buildhome/repo/src/modules/global/components/selected-items-display/selected-items-display.vue"],"names":[],"mappings":"AAoDA;EACE,YAAA;AAnDF","file":"selected-items-display.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.selected-items\n  min-width: 0\n"]}]);
// Exports
module.exports = exports;
